package com.iptvplayer.shared.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class ChannelQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    sourceId: String,
    name: String,
    streamUrl: String,
    logoUrl: String?,
    groupName: String?,
    streamType: String,
  ) -> T): Query<T> = Query(1_466_880_830, arrayOf("ChannelEntity"), driver, "Channel.sq",
      "selectAll",
      "SELECT ChannelEntity.id, ChannelEntity.sourceId, ChannelEntity.name, ChannelEntity.streamUrl, ChannelEntity.logoUrl, ChannelEntity.groupName, ChannelEntity.streamType FROM ChannelEntity") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6)!!
    )
  }

  public fun selectAll(): Query<ChannelEntity> = selectAll { id, sourceId, name, streamUrl, logoUrl,
      groupName, streamType ->
    ChannelEntity(
      id,
      sourceId,
      name,
      streamUrl,
      logoUrl,
      groupName,
      streamType
    )
  }

  public fun <T : Any> selectBySourceId(sourceId: String, mapper: (
    id: String,
    sourceId: String,
    name: String,
    streamUrl: String,
    logoUrl: String?,
    groupName: String?,
    streamType: String,
  ) -> T): Query<T> = SelectBySourceIdQuery(sourceId) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6)!!
    )
  }

  public fun selectBySourceId(sourceId: String): Query<ChannelEntity> = selectBySourceId(sourceId) {
      id, sourceId_, name, streamUrl, logoUrl, groupName, streamType ->
    ChannelEntity(
      id,
      sourceId_,
      name,
      streamUrl,
      logoUrl,
      groupName,
      streamType
    )
  }

  public fun <T : Any> selectByGroup(groupName: String?, mapper: (
    id: String,
    sourceId: String,
    name: String,
    streamUrl: String,
    logoUrl: String?,
    groupName: String?,
    streamType: String,
  ) -> T): Query<T> = SelectByGroupQuery(groupName) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6)!!
    )
  }

  public fun selectByGroup(groupName: String?): Query<ChannelEntity> = selectByGroup(groupName) {
      id, sourceId, name, streamUrl, logoUrl, groupName_, streamType ->
    ChannelEntity(
      id,
      sourceId,
      name,
      streamUrl,
      logoUrl,
      groupName_,
      streamType
    )
  }

  public fun selectGroups(): Query<String> = Query(-1_267_908_841, arrayOf("ChannelEntity"), driver,
      "Channel.sq", "selectGroups",
      "SELECT DISTINCT groupName FROM ChannelEntity WHERE groupName IS NOT NULL ORDER BY groupName") {
      cursor ->
    cursor.getString(0)!!
  }

  public fun <T : Any> search(`value`: String, mapper: (
    id: String,
    sourceId: String,
    name: String,
    streamUrl: String,
    logoUrl: String?,
    groupName: String?,
    streamType: String,
  ) -> T): Query<T> = SearchQuery(value) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6)!!
    )
  }

  public fun search(value_: String): Query<ChannelEntity> = search(value_) { id, sourceId, name,
      streamUrl, logoUrl, groupName, streamType ->
    ChannelEntity(
      id,
      sourceId,
      name,
      streamUrl,
      logoUrl,
      groupName,
      streamType
    )
  }

  public fun <T : Any> pageFiltered(
    group: String?,
    query: String?,
    limit: Long,
    offset: Long,
    mapper: (
      id: String,
      sourceId: String,
      name: String,
      streamUrl: String,
      logoUrl: String?,
      groupName: String?,
      streamType: String,
    ) -> T,
  ): Query<T> = PageFilteredQuery(group, query, limit, offset) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6)!!
    )
  }

  public fun pageFiltered(
    group: String?,
    query: String?,
    limit: Long,
    offset: Long,
  ): Query<ChannelEntity> = pageFiltered(group, query, limit, offset) { id, sourceId, name,
      streamUrl, logoUrl, groupName, streamType ->
    ChannelEntity(
      id,
      sourceId,
      name,
      streamUrl,
      logoUrl,
      groupName,
      streamType
    )
  }

  public fun countFiltered(group: String?, query: String?): Query<Long> = CountFilteredQuery(group,
      query) { cursor ->
    cursor.getLong(0)!!
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    sourceId: String,
    name: String,
    streamUrl: String,
    logoUrl: String?,
    groupName: String?,
    streamType: String,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6)!!
    )
  }

  public fun selectById(id: String): Query<ChannelEntity> = selectById(id) { id_, sourceId, name,
      streamUrl, logoUrl, groupName, streamType ->
    ChannelEntity(
      id_,
      sourceId,
      name,
      streamUrl,
      logoUrl,
      groupName,
      streamType
    )
  }

  public fun <T : Any> nextByName(
    group: String?,
    name: String,
    id: String,
    mapper: (
      id: String,
      sourceId: String,
      name: String,
      streamUrl: String,
      logoUrl: String?,
      groupName: String?,
      streamType: String,
    ) -> T,
  ): Query<T> = NextByNameQuery(group, name, id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6)!!
    )
  }

  public fun nextByName(
    group: String?,
    name: String,
    id: String,
  ): Query<ChannelEntity> = nextByName(group, name, id) { id_, sourceId, name_, streamUrl, logoUrl,
      groupName, streamType ->
    ChannelEntity(
      id_,
      sourceId,
      name_,
      streamUrl,
      logoUrl,
      groupName,
      streamType
    )
  }

  public fun <T : Any> prevByName(
    group: String?,
    name: String,
    id: String,
    mapper: (
      id: String,
      sourceId: String,
      name: String,
      streamUrl: String,
      logoUrl: String?,
      groupName: String?,
      streamType: String,
    ) -> T,
  ): Query<T> = PrevByNameQuery(group, name, id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6)!!
    )
  }

  public fun prevByName(
    group: String?,
    name: String,
    id: String,
  ): Query<ChannelEntity> = prevByName(group, name, id) { id_, sourceId, name_, streamUrl, logoUrl,
      groupName, streamType ->
    ChannelEntity(
      id_,
      sourceId,
      name_,
      streamUrl,
      logoUrl,
      groupName,
      streamType
    )
  }

  public fun <T : Any> firstByName(group: String?, mapper: (
    id: String,
    sourceId: String,
    name: String,
    streamUrl: String,
    logoUrl: String?,
    groupName: String?,
    streamType: String,
  ) -> T): Query<T> = FirstByNameQuery(group) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6)!!
    )
  }

  public fun firstByName(group: String?): Query<ChannelEntity> = firstByName(group) { id, sourceId,
      name, streamUrl, logoUrl, groupName, streamType ->
    ChannelEntity(
      id,
      sourceId,
      name,
      streamUrl,
      logoUrl,
      groupName,
      streamType
    )
  }

  public fun <T : Any> lastByName(group: String?, mapper: (
    id: String,
    sourceId: String,
    name: String,
    streamUrl: String,
    logoUrl: String?,
    groupName: String?,
    streamType: String,
  ) -> T): Query<T> = LastByNameQuery(group) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6)!!
    )
  }

  public fun lastByName(group: String?): Query<ChannelEntity> = lastByName(group) { id, sourceId,
      name, streamUrl, logoUrl, groupName, streamType ->
    ChannelEntity(
      id,
      sourceId,
      name,
      streamUrl,
      logoUrl,
      groupName,
      streamType
    )
  }

  public fun insert(
    id: String,
    sourceId: String,
    name: String,
    streamUrl: String,
    logoUrl: String?,
    groupName: String?,
    streamType: String,
  ) {
    driver.execute(-951_427_808, """
        |INSERT OR REPLACE INTO ChannelEntity(id, sourceId, name, streamUrl, logoUrl, groupName, streamType)
        |VALUES (?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 7) {
          bindString(0, id)
          bindString(1, sourceId)
          bindString(2, name)
          bindString(3, streamUrl)
          bindString(4, logoUrl)
          bindString(5, groupName)
          bindString(6, streamType)
        }
    notifyQueries(-951_427_808) { emit ->
      emit("ChannelEntity")
    }
  }

  public fun deleteBySourceId(sourceId: String) {
    driver.execute(2_011_532_735, """DELETE FROM ChannelEntity WHERE sourceId = ?""", 1) {
          bindString(0, sourceId)
        }
    notifyQueries(2_011_532_735) { emit ->
      emit("ChannelEntity")
    }
  }

  public fun deleteAll() {
    driver.execute(-1_470_820_305, """DELETE FROM ChannelEntity""", 0)
    notifyQueries(-1_470_820_305) { emit ->
      emit("ChannelEntity")
    }
  }

  private inner class SelectBySourceIdQuery<out T : Any>(
    public val sourceId: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("ChannelEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("ChannelEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-435_418_160,
        """SELECT ChannelEntity.id, ChannelEntity.sourceId, ChannelEntity.name, ChannelEntity.streamUrl, ChannelEntity.logoUrl, ChannelEntity.groupName, ChannelEntity.streamType FROM ChannelEntity WHERE sourceId = ?""",
        mapper, 1) {
      bindString(0, sourceId)
    }

    override fun toString(): String = "Channel.sq:selectBySourceId"
  }

  private inner class SelectByGroupQuery<out T : Any>(
    public val groupName: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("ChannelEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("ChannelEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null,
        """SELECT ChannelEntity.id, ChannelEntity.sourceId, ChannelEntity.name, ChannelEntity.streamUrl, ChannelEntity.logoUrl, ChannelEntity.groupName, ChannelEntity.streamType FROM ChannelEntity WHERE groupName ${ if (groupName == null) "IS" else "=" } ?""",
        mapper, 1) {
      bindString(0, groupName)
    }

    override fun toString(): String = "Channel.sq:selectByGroup"
  }

  private inner class SearchQuery<out T : Any>(
    public val `value`: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("ChannelEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("ChannelEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-673_972_209,
        """SELECT ChannelEntity.id, ChannelEntity.sourceId, ChannelEntity.name, ChannelEntity.streamUrl, ChannelEntity.logoUrl, ChannelEntity.groupName, ChannelEntity.streamType FROM ChannelEntity WHERE name LIKE '%' || ? || '%'""",
        mapper, 1) {
      bindString(0, value)
    }

    override fun toString(): String = "Channel.sq:search"
  }

  private inner class PageFilteredQuery<out T : Any>(
    public val group: String?,
    public val query: String?,
    public val limit: Long,
    public val offset: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("ChannelEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("ChannelEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT ChannelEntity.id, ChannelEntity.sourceId, ChannelEntity.name, ChannelEntity.streamUrl, ChannelEntity.logoUrl, ChannelEntity.groupName, ChannelEntity.streamType FROM ChannelEntity
    |WHERE (? IS NULL OR groupName ${ if (group == null) "IS" else "=" } ?)
    |  AND (? IS NULL OR name LIKE '%' || ? || '%')
    |ORDER BY name
    |LIMIT ? OFFSET ?
    """.trimMargin(), mapper, 6) {
      bindString(0, group)
      bindString(1, group)
      bindString(2, query)
      bindString(3, query)
      bindLong(4, limit)
      bindLong(5, offset)
    }

    override fun toString(): String = "Channel.sq:pageFiltered"
  }

  private inner class CountFilteredQuery<out T : Any>(
    public val group: String?,
    public val query: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("ChannelEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("ChannelEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT COUNT(*) FROM ChannelEntity
    |WHERE (? IS NULL OR groupName ${ if (group == null) "IS" else "=" } ?)
    |  AND (? IS NULL OR name LIKE '%' || ? || '%')
    """.trimMargin(), mapper, 4) {
      bindString(0, group)
      bindString(1, group)
      bindString(2, query)
      bindString(3, query)
    }

    override fun toString(): String = "Channel.sq:countFiltered"
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("ChannelEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("ChannelEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_771_293_227,
        """SELECT ChannelEntity.id, ChannelEntity.sourceId, ChannelEntity.name, ChannelEntity.streamUrl, ChannelEntity.logoUrl, ChannelEntity.groupName, ChannelEntity.streamType FROM ChannelEntity WHERE id = ? LIMIT 1""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Channel.sq:selectById"
  }

  private inner class NextByNameQuery<out T : Any>(
    public val group: String?,
    public val name: String,
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("ChannelEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("ChannelEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT ChannelEntity.id, ChannelEntity.sourceId, ChannelEntity.name, ChannelEntity.streamUrl, ChannelEntity.logoUrl, ChannelEntity.groupName, ChannelEntity.streamType FROM ChannelEntity
    |WHERE (? IS NULL OR groupName ${ if (group == null) "IS" else "=" } ?)
    |  AND (name > ? OR (name = ? AND id > ?))
    |ORDER BY name ASC, id ASC
    |LIMIT 1
    """.trimMargin(), mapper, 5) {
      bindString(0, group)
      bindString(1, group)
      bindString(2, name)
      bindString(3, name)
      bindString(4, id)
    }

    override fun toString(): String = "Channel.sq:nextByName"
  }

  private inner class PrevByNameQuery<out T : Any>(
    public val group: String?,
    public val name: String,
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("ChannelEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("ChannelEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT ChannelEntity.id, ChannelEntity.sourceId, ChannelEntity.name, ChannelEntity.streamUrl, ChannelEntity.logoUrl, ChannelEntity.groupName, ChannelEntity.streamType FROM ChannelEntity
    |WHERE (? IS NULL OR groupName ${ if (group == null) "IS" else "=" } ?)
    |  AND (name < ? OR (name = ? AND id < ?))
    |ORDER BY name DESC, id DESC
    |LIMIT 1
    """.trimMargin(), mapper, 5) {
      bindString(0, group)
      bindString(1, group)
      bindString(2, name)
      bindString(3, name)
      bindString(4, id)
    }

    override fun toString(): String = "Channel.sq:prevByName"
  }

  private inner class FirstByNameQuery<out T : Any>(
    public val group: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("ChannelEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("ChannelEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT ChannelEntity.id, ChannelEntity.sourceId, ChannelEntity.name, ChannelEntity.streamUrl, ChannelEntity.logoUrl, ChannelEntity.groupName, ChannelEntity.streamType FROM ChannelEntity
    |WHERE (? IS NULL OR groupName ${ if (group == null) "IS" else "=" } ?)
    |ORDER BY name ASC, id ASC
    |LIMIT 1
    """.trimMargin(), mapper, 2) {
      bindString(0, group)
      bindString(1, group)
    }

    override fun toString(): String = "Channel.sq:firstByName"
  }

  private inner class LastByNameQuery<out T : Any>(
    public val group: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("ChannelEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("ChannelEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT ChannelEntity.id, ChannelEntity.sourceId, ChannelEntity.name, ChannelEntity.streamUrl, ChannelEntity.logoUrl, ChannelEntity.groupName, ChannelEntity.streamType FROM ChannelEntity
    |WHERE (? IS NULL OR groupName ${ if (group == null) "IS" else "=" } ?)
    |ORDER BY name DESC, id DESC
    |LIMIT 1
    """.trimMargin(), mapper, 2) {
      bindString(0, group)
      bindString(1, group)
    }

    override fun toString(): String = "Channel.sq:lastByName"
  }
}
